/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_MessagesInputs */

const cs_nav_messages = /** @type {(inputs: Nav_MessagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zprávy`)
};

const en_nav_messages = /** @type {(inputs: Nav_MessagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Messages`)
};

/**
* | output |
* | --- |
* | "Messages" |
*
* @param {Nav_MessagesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_messages = /** @type {((inputs?: Nav_MessagesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_MessagesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_messages(inputs)
	return cs_nav_messages(inputs)
});